import { PerformanceIndicatorCalculationRange, PerformanceIndicatorGroup, RequestStatus, defaults, entities } from 'typed/api';
import { combineReducers, switchReducers, synchronizableEnumReducer } from './utils';
import { deepAssign } from 'typed/utils';
import { UntypedAction } from 'typed/actions';

// TODO find a way to infer this
const gs = defaults.NetworkArrayOf(defaults.PerformanceIndicatorGroupReport);

export default combineReducers({
    indicatorGroups: switchReducers(gs,
        synchronizableEnumReducer(gs, 'LOAD_ALL_PERFORMANCE_INDICATOR_GROUPS', PerformanceIndicatorGroup as any, 'PerformanceIndicatorGroup'),
        (state: entities.NetworkArray<entities.PerformanceIndicatorGroupReport> = gs, action: UntypedAction) =>
            action.type === 'LOAD_ALL_PERFORMANCE_INDICATORS_SUCCESS' ||
                action.type === 'ADD_PERFORMANCE_INDICATOR_SUCCESS' ||
                action.type === 'EDIT_PERFORMANCE_INDICATOR_SUCCESS' ||
                action.type === 'DELETE_PERFORMANCE_INDICATOR_SUCCESS' ||
                action.type === 'VOID_ALL_PERFORMANCE_INDICATORS' ||
                action.type === 'IMPORT_AND_PROCESS_GOOGLE_SHEETS_DATA_SUCCESS' ||
                action.type === 'SPLIT_FINANCIAL_INDICATOR_TO_SUB_ACCOUNTS_SUCCESS' ||
                action.type === 'ADD_SEVERA_INTEGRATION_SETTINGS_SUCCESS' ||
                action.type === 'EDIT_SEVERA_INTEGRATION_SETTINGS_SUCCESS' ||
                action.type === 'DELETE_SEVERA_INTEGRATION_SETTINGS_SUCCESS' ?
                deepAssign(state, { Custom: { status: RequestStatus.UNSYNCED } }) :
                state
    ),
    performanceIndicatorCalculationRanges: synchronizableEnumReducer(
        defaults.NetworkArrayOf(defaults.PerformanceIndicatorCalculationRange),
        'LOAD_ALL_PERFORMANCE_INDICATOR_CALCULATION_RANGES',
        PerformanceIndicatorCalculationRange as any,
        'PerformanceIndicatorCalculationRange'
    )
});
